import React from 'react';
import { Table, Badge, Form } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const TablaEmpresasYaBorradas = ({
    candidatasPaginadas,
    licenciasSeleccionadas = [],
    todasSeleccionadasPaginaActual = false,
    toggleSeleccionarTodo = () => {},
    toggleSeleccion = () => {},
    cargando = false,
    formatearFechaLarga,
    formatearFechaCorta,
    copiarAlPortapapeles,
    estatusBorrado = 3,
    isAdmin = true,
    handleReintentarBorrado = () => {},
    handleDescartarNoBorradas = () => {}
}) => {
    const esNoBorradas = estatusBorrado === 2;

    return (
        <>
            {/* Vista Móvil (Cards) */}
            <div className="d-md-none p-2">
                {esNoBorradas && isAdmin && candidatasPaginadas.length > 0 && (
                    <div className="d-flex align-items-center justify-content-between p-2 mb-2 bg-light rounded border">
                        <Form.Check
                            type="checkbox"
                            id="select-all-mobile-no-borradas"
                            label={<span className="fs--1 fw-semi-bold">Seleccionar página</span>}
                            checked={todasSeleccionadasPaginaActual}
                            onChange={toggleSeleccionarTodo}
                            disabled={candidatasPaginadas.length === 0}
                        />
                        {licenciasSeleccionadas.length > 0 && (
                            <span className="badge bg-soft-primary text-primary fs--2">
                                {licenciasSeleccionadas.length} seleccionada(s)
                            </span>
                        )}
                    </div>
                )}

                {candidatasPaginadas.length > 0 ? (
                    candidatasPaginadas.map((row, idx) => {
                        const isSelected = !!licenciasSeleccionadas.find(l => l.idLicencia === row.idLicencia);
                        return (
                            <div
                                key={row.idLicencia || row.idProgramacion || idx}
                                className={`card mb-2 shadow-none border ${isSelected ? 'border-primary bg-soft-primary-light' : ''}`}
                                style={{ borderRadius: '10px' }}
                            >
                                <div className="card-body p-3">
                                    {/* Encabezado: Checkbox, ID y Tipo Licencia */}
                                    <div className="d-flex justify-content-between align-items-start mb-2">
                                        <div className="d-flex align-items-center gap-2">
                                            {esNoBorradas && isAdmin && (
                                                <Form.Check
                                                    type="checkbox"
                                                    checked={isSelected}
                                                    onChange={() => toggleSeleccion(row)}
                                                />
                                            )}
                                            <Link to={"/licencias/detalle/" + row.idLicencia} className="fw-bold fs--1 text-900 text-decoration-none">
                                                ID: #{row.idLicencia}
                                            </Link>
                                        </div>
                                        <Badge
                                            bg={row.vTipoLicencia === 'Nube' ? 'soft-primary' : 'soft-info'}
                                            className={row.vTipoLicencia === 'Nube' ? 'text-primary' : 'text-info'}
                                        >
                                            {row.vTipoLicencia || 'Desconocido'}
                                        </Badge>
                                    </div>

                                    {/* Empresa */}
                                    <div className="mb-2">
                                        <div className="fw-bold fs--1 text-dark text-break">
                                            {row.vNombreEmpresa || 'Sin Nombre'}
                                        </div>
                                    </div>

                                    {/* Motivo / Estatus Destacado */}
                                    <div className={`p-2 rounded mb-2 fs--2 ${esNoBorradas ? 'bg-soft-danger text-danger' : 'bg-soft-success text-success'}`}>
                                        <div className="fw-semi-bold mb-1">
                                            <i className={`fas ${esNoBorradas ? 'fa-ban' : 'fa-check-circle'} me-1`} />
                                            {esNoBorradas ? 'Motivo de No Borrado:' : 'Estatus de Borrado:'}
                                        </div>
                                        <div className="text-break" style={{ lineHeight: 1.4 }}>
                                            {row.vMotivo || (esNoBorradas ? 'Cuenta con licencia vigente' : 'Borrado exitoso')}
                                        </div>
                                    </div>

                                    {/* Fechas y Servidor */}
                                    <div className="bg-light p-2 rounded mb-2 fs--2">
                                        <div className="d-flex justify-content-between align-items-center mb-1">
                                            <span className="text-600">{esNoBorradas ? 'Fecha Programación:' : 'Fecha de Borrado:'}</span>
                                            <span className="fw-semi-bold text-700">
                                                {formatearFechaLarga(esNoBorradas ? (row.dFechaProgramacion || row.dFechaAgregada) : (row.dFechaBorrado || row.dFechaProgramacion))}
                                            </span>
                                        </div>
                                        <div className="d-flex justify-content-between align-items-center mb-1">
                                            <span className="text-600">{esNoBorradas ? 'Servidor Prog.:' : 'Servidor Borrado:'}</span>
                                            <span className="text-800">{row.vServer || 'N/A'}</span>
                                        </div>
                                        <div className="d-flex justify-content-between align-items-center">
                                            <span className="text-600">{esNoBorradas ? 'BD Prog.:' : 'BD Borrada:'}</span>
                                            <span className="text-800 fw-semi-bold">{row.vDatabase || 'N/A'}</span>
                                        </div>
                                    </div>

                                    {row.bTieneLicenciaVigente && (
                                        <div className="p-2 border border-warning rounded bg-white mb-2 fs--2">
                                            <Badge bg="soft-warning" className="text-warning mb-1">
                                                Vigente ({row.vTipoLicenciaVigente || 'Activa'})
                                            </Badge>
                                            <div className="text-800"><strong>Servidor:</strong> {row.vServerVigente || 'N/A'}</div>
                                            <div className="text-800"><strong>BD:</strong> {row.vDatabaseVigente || 'N/A'}</div>
                                            {row.dFinLicenciaVigente && (
                                                <div className="text-600">Vence: {formatearFechaCorta(row.dFinLicenciaVigente)}</div>
                                            )}
                                        </div>
                                    )}

                                    {/* UUID */}
                                    <div className="d-flex justify-content-between align-items-center pt-2 border-top fs--2">
                                        <span className="text-muted">UUID:</span>
                                        <span
                                            className="text-primary font-monospace cursor-pointer text-truncate"
                                            style={{ maxWidth: '240px' }}
                                            onClick={() => copiarAlPortapapeles(row.vUUIDEmpresa)}
                                            title="Haz clic para copiar UUID"
                                        >
                                            <i className="far fa-copy me-1" />
                                            {row.vUUIDEmpresa || 'N/A'}
                                        </span>
                                    </div>

                                    {/* Acciones individuales en Mobile */}
                                    {esNoBorradas && isAdmin && (
                                        <div className="d-flex justify-content-end gap-2 pt-2 border-top mt-2">
                                            <button
                                                type="button"
                                                className="btn btn-sm btn-outline-primary d-flex align-items-center gap-1 fs--2 px-2 py-1"
                                                onClick={() => handleReintentarBorrado(row)}
                                                disabled={cargando}
                                            >
                                                <i className="fas fa-redo"></i>
                                                <span>Reintentar</span>
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-sm btn-outline-danger d-flex align-items-center gap-1 fs--2 px-2 py-1"
                                                onClick={() => handleDescartarNoBorradas(row)}
                                                disabled={cargando}
                                            >
                                                <i className="fas fa-trash-alt"></i>
                                                <span>Descartar</span>
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </div>
                        );
                    })
                ) : (
                    <div className="text-center py-4 text-muted fs--1">
                        {cargando ? 'Cargando datos...' : (esNoBorradas ? 'No hay registros de bases de datos omitidas o con error.' : 'No hay bases de datos borradas registradas.')}
                    </div>
                )}
            </div>

            {/* Vista Escritorio (Tabla tradicional) */}
            <div className="table-responsive bg-white d-none d-md-block">
                <Table striped hover className="fs--1 mb-0 align-middle text-nowrap">
                    <thead className="bg-200 text-900">
                        <tr>
                            {esNoBorradas && isAdmin && (
                                <th style={{ width: '40px' }} className="ps-3">
                                    <Form.Check
                                        type="checkbox"
                                        id="select-all-no-borradas"
                                        checked={todasSeleccionadasPaginaActual}
                                        onChange={toggleSeleccionarTodo}
                                        disabled={candidatasPaginadas.length === 0}
                                    />
                                </th>
                            )}
                            <th className={esNoBorradas && isAdmin ? '' : 'ps-3'}>ID Licencia</th>
                            <th>Empresa</th>
                            <th>Tipo Licencia</th>
                            <th>{esNoBorradas ? 'Servidor / BD Programada' : 'Servidor / BD Borrada'}</th>
                            <th>{esNoBorradas ? 'Fecha Programación' : 'Fecha de Borrado'}</th>
                            <th>BD y Servidor Vigente</th>
                            <th style={{ minWidth: '320px' }}>{esNoBorradas ? 'Motivo de No Borrado' : 'Motivo / Estatus'}</th>
                            <th>UUID Empresa</th>
                            {esNoBorradas && isAdmin && (
                                <th className="text-center pe-3" style={{ width: '130px' }}>Acciones</th>
                            )}
                        </tr>
                    </thead>
                    <tbody>
                        {candidatasPaginadas.length > 0 ? (
                            candidatasPaginadas.map((row, idx) => {
                                const isSelected = !!licenciasSeleccionadas.find(l => l.idLicencia === row.idLicencia);
                                return (
                                    <tr key={row.idLicencia || row.idProgramacion || idx} className={isSelected ? 'table-primary' : ''}>
                                        {esNoBorradas && isAdmin && (
                                            <td className="ps-3" style={{ width: '40px' }}>
                                                <Form.Check
                                                    type="checkbox"
                                                    id={`checkbox-row-${row.idLicencia}`}
                                                    checked={isSelected}
                                                    onChange={() => toggleSeleccion(row)}
                                                />
                                            </td>
                                        )}
                                        <td className={esNoBorradas && isAdmin ? '' : 'ps-3'}>
                                            <Link to={"/licencias/detalle/" + row.idLicencia}>
                                                <strong>{row.idLicencia}</strong>
                                            </Link>
                                        </td>
                                        <td>
                                            <span className="d-inline-block text-truncate fs--1 text-800 fw-semi-bold" style={{ maxWidth: '220px' }}>
                                                {row.vNombreEmpresa || 'Sin Nombre'}
                                            </span>
                                        </td>
                                        <td>
                                            <Badge
                                                bg={row.vTipoLicencia === 'Nube' ? 'soft-primary' : 'soft-info'}
                                                className={row.vTipoLicencia === 'Nube' ? 'text-primary' : 'text-info'}
                                            >
                                                {row.vTipoLicencia || 'Desconocido'}
                                            </Badge>
                                        </td>
                                        <td>
                                            <div>
                                                <div className="text-700 fs--2">{row.vServer || 'N/A'}</div>
                                                <div className="text-700 fs--2 fw-semi-bold">{row.vDatabase || 'N/A'}</div>
                                            </div>
                                        </td>
                                        <td>
                                            <span className="fs--1 text-700">
                                                {formatearFechaLarga(esNoBorradas ? (row.dFechaProgramacion || row.dFechaAgregada) : (row.dFechaBorrado || row.dFechaProgramacion))}
                                            </span>
                                        </td>
                                        <td>
                                            {row.bTieneLicenciaVigente ? (
                                                <div className="p-1 px-2 border border-warning rounded bg-white">
                                                    <Badge bg="soft-warning" className="text-warning mb-1">
                                                        Vigente ({row.vTipoLicenciaVigente || 'Activa'})
                                                    </Badge>
                                                    <div className="text-800 fs--2"><strong>Servidor:</strong> {row.vServerVigente || 'N/A'}</div>
                                                    <div className="text-800 fs--2"><strong>BD:</strong> {row.vDatabaseVigente || 'N/A'}</div>
                                                    {row.dFinLicenciaVigente && (
                                                        <div className="text-600 fs--2">Vence: {formatearFechaCorta(row.dFinLicenciaVigente)}</div>
                                                    )}
                                                </div>
                                            ) : (
                                                <Badge bg="soft-secondary" className="text-secondary">
                                                    Sin licencia vigente
                                                </Badge>
                                            )}
                                        </td>
                                        <td style={{ whiteSpace: 'normal', minWidth: '320px', maxWidth: '480px', wordBreak: 'break-word' }}>
                                            {esNoBorradas ? (
                                                <span className="fs--2 text-danger fw-semi-bold d-inline-block" style={{ lineHeight: 1.4 }} title={row.vMotivo || 'Cuenta con licencia vigente'}>
                                                    <i className="fas fa-ban me-1"></i>
                                                    {row.vMotivo || 'Cuenta con licencia vigente'}
                                                </span>
                                            ) : (
                                                <span className="fs--2 text-success fw-semi-bold d-inline-block" style={{ lineHeight: 1.4 }} title={row.vMotivo || 'Borrado exitoso'}>
                                                    <i className="fas fa-check-circle me-1"></i>
                                                    {row.vMotivo || 'Borrado exitoso'}
                                                </span>
                                            )}
                                        </td>
                                        <td className={esNoBorradas && isAdmin ? '' : 'pe-3'}>
                                            <span
                                                className="text-700 fs--2 font-monospace cursor-pointer"
                                                onClick={() => copiarAlPortapapeles(row.vUUIDEmpresa)}
                                                title="Haz clic para copiar UUID"
                                            >
                                                {row.vUUIDEmpresa || 'N/A'}
                                            </span>
                                        </td>
                                        {esNoBorradas && isAdmin && (
                                            <td className="text-center pe-3">
                                                <div className="d-flex justify-content-center align-items-center gap-1">
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-outline-primary p-1 px-2 fs--2 d-flex align-items-center gap-1"
                                                        onClick={() => handleReintentarBorrado(row)}
                                                        title="Reintentar / Volver a Programar"
                                                        disabled={cargando}
                                                    >
                                                        <i className="fas fa-redo"></i>
                                                        <span className="d-none d-lg-inline">Reintentar</span>
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-outline-danger p-1 px-2 fs--2 d-flex align-items-center gap-1"
                                                        onClick={() => handleDescartarNoBorradas(row)}
                                                        title="Descartar / Quitar de la lista"
                                                        disabled={cargando}
                                                    >
                                                        <i className="fas fa-trash-alt"></i>
                                                        <span className="d-none d-lg-inline">Descartar</span>
                                                    </button>
                                                </div>
                                            </td>
                                        )}
                                    </tr>
                                );
                            })
                        ) : (
                            <tr>
                                <td colSpan={esNoBorradas && isAdmin ? 10 : 8} className="text-center py-4 text-muted fs--1">
                                    {cargando ? 'Cargando datos...' : (esNoBorradas ? 'No hay registros de bases de datos omitidas o con error.' : 'No hay bases de datos borradas registradas.')}
                                </td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            </div>
        </>
    );
};

export default TablaEmpresasYaBorradas;
